<template>
  <div>
    <el-table
    :data="tableData"
    stripe
    :height="tabH">
      <el-table-column
        v-for="col in cols"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        key="edit"
        label="审核"
        width="80">
        <template v-if="col.prop == 'edit'" scope="scope">
          <el-button size="small" @click="edit(scope.row.guid)"><i class="el-icon-edit"></i></el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import problemUserSubmitDlg from '@/components/problemUserSubmitDlg'
  export default {
    data () {
      return {
        cols: [
          {
            prop: 'id',
            label: 'id',
            width: 80
          },
          {
            prop: 'guid',
            label: 'guid',
            width: 100
          },
          {
            prop: 'userGuid',
            label: 'userGuid',
            width: 100
          },
          {
            prop: 'keywords',
            label: '关键词',
            width: 100
          },
          {
            prop: 'title',
            label: '标题',
            width: 100
          },
          {
            prop: 'content',
            label: '内容',
            width: 100
          },
          {
            prop: 'imgs',
            label: '关键词',
            width: 150
          },
          {
            prop: 'date',
            label: '提交日期',
            width: 150
          },
          {
            prop: 'isUsed',
            label: '是否采纳',
            width: 150
          }
        ]
      }
    },
    props: ['tableData'],
    computed: {
      tabH () {
        return this.winH - (this.search ? this.search.getHeight() : 80) - 88
      }
    },
    created () {
      console.log('----11----')
    },
    methods: {
      edit (guid) {
        console.log('审核用户上传的题目->edit guid = ', guid)
        problemUserSubmitDlg({
          guid: guid
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// prepareProblemTableUser.vue?5f489104